<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/production/palletized/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-boxes"></i><span class="space-icon"></span>
      {{ $t("labels.packages_from_stock_title") }}
    </h1>

    <div class="mt-4 flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="`${getFormatNumber(total_rows)} ${$t(
            'labels.total_packages_from_stock'
          )}`"
        />
      </div>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="width: 100%; height: 600px"
        class="ag-theme-alpine w-full h-full"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef()"
        :rowData="packages_from_stock"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="Number(total_rows) > rows_per_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    >
    </table-paginator>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/palletized/show_process.js";
import { AgGridVue } from "ag-grid-vue3";
import { dateFilter } from "@/components/views/mixins/ag_grid_filters.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "PHProductionPalletizedShowProcessPackagesFromStock",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      current_page: 1,
      rows_per_page: 12,
      packages_from_stock: [],
      total_rows: 0,
      columnDefs: [
        {
          headerName: this.$t("model.package.week"),
          field: "week",
          filter: "agNumberColumnFilter",
          flex: 1,
        },
        {
          headerName: this.$t("model.package.registered_at"),
          valueGetter: (params) => {
            return params.data.registered_at;
          },
          valueFormatter: (params) => {
            return this.dateFormatter(params.data.registered_at);
          },
          filter: "agDateColumnFilter",
          flex: 1,
          filterParams: dateFilter,
        },
        {
          headerName: this.$t("model.package.producer"),
          field: "entity_name",
          flex: 2,
        },
        {
          headerName: this.$t("model.package.exported_batch"),
          field: "exported_batch.batch_code",
          flex: 1,
        },
        {
          headerName: this.$t("model.package.quantity"),
          field: "quantity",
          filter: "agNumberColumnFilter",
          flex: 1,
        },
        {
          headerName: this.$t("model.package.exporter_process_crop_package"),
          field: "exporter_process_crop_package.label",
          flex: 1,
        },
        {
          headerName: this.$t("model.package.exporter_process_crop_category"),
          field: "exporter_process_crop_category.name",
          flex: 1,
        },
        {
          headerName: this.$t("model.package.exporter_process_brand"),
          field: "exporter_process_brand.agro_exporter_brand.name",
          flex: 1,
        },
      ],
    };
  },
  props: {
    packing_house_id: { required: true },
    packing_house_process_id: { required: true },
  },
  computed: {},
  watch: {
    current_page: function () {
      this.fetchPackagesFromStock();
    },
  },
  created() {
    this.fetchPackagesFromStock();
  },
  methods: {
    fetchPackagesFromStock: async function () {
      const response = await Requester.fetchPackagesFromStock(
        this.packing_house_id,
        this.packing_house_process_id,
        this.current_page,
        this.rows_per_page
      );
      this.total_rows = response.data.total_rows;
      this.packages_from_stock = response.data.records;
    },
    defaultColDef: function () {
      return {
        sortable: true,
        floatingFilter: true,
        resizable: true,
        filter: true,
      };
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();
    },
  },
};
</script>
